var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h1", [_vm._v(_vm._s(_vm.title))]),
    _vm._v(" "),
    _c("div", { staticClass: "tag-sections" }, [
      _c(
        "section",
        { staticClass: "tag" },
        [
          _c("div", { staticClass: "font-weight-extra-bold" }, [
            _vm._v("Mehrfachauswahl möglich")
          ]),
          _vm._v(" "),
          _c("CharacteristicSelectInline", {
            attrs: {
              "characteristic-items": _vm.meta.careerLevel,
              "initial-amount": 9,
              "label-type": "application"
            },
            on: { input: _vm.emitChangeEvent },
            model: {
              value: _vm.careerLevels,
              callback: function($$v) {
                _vm.careerLevels = $$v
              },
              expression: "careerLevels"
            }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }